import React, { useEffect, useState } from "react";
import cn from "classnames";

import Star from "./Star";

import styles from "./styles.module.scss";

export default function StarRate({ onStarsCountChange, value, maxRate, className }) {
    const [rating, setRating] = useState(value || 0);

    const handleMouseEnter = (index) => {
        onStarsCountChange && setRating(index);
    };

    const handleMouseOut = (event) => {
        onStarsCountChange && setRating(value || 0);
    };

    const handleStarClick = (index) => {
        onStarsCountChange && onStarsCountChange(index);
    };

    useEffect(() => {
        if (value !== rating) {
            setRating(value);
        }
    }, [rating, value]);

    return (
        <div
            className={cn(styles.stars, !onStarsCountChange && styles.stars__disabled, className)}
            onMouseLeave={handleMouseOut}
        >
            {[...Array(maxRate).keys()].map((el, index) => (
                <Star
                    key={index}
                    fillType={index + 1 <= rating ? "fill" : "none"}
                    index={index + 1}
                    onMouseEnter={handleMouseEnter}
                    onClick={handleStarClick}
                />
            ))}
        </div>
    );
}
